import React, { useContext, useEffect, useState } from 'react';
import { FirestoreContext } from '../../../../../utils/store/context/firestoreContext';

const SelectSpecialization = (props) => {
	/* ===== FIREBASE CONTEXT =====*/
	const { getCategories, categories } = useContext(FirestoreContext);
	// const [getCount, setGetCount] = useState(true);
	// if (getCount) {
	// 	getCategories();
	// 	setGetCount(false);
	// }
	const { changeFn } = props;
	const [selectedCat, setSelectedCat] = useState('');
	const [category, setCategory] = useState();
	const [subCategory, setSubCategory] = useState('');
	const [showSubCat, setShowSubCat] = useState(false);
	const [showSpecialization, setShowSpecialization] = useState(false);
	/* ===== OTHER VARIABLES =====*/
	let selectedCategory;
	let selectedSubCategory;
	let sub_cat_select;

	/* eslint-disable */
	useEffect(() => {
		getCategories();
	}, []);

	// Get subCategories
	useEffect(() => {
		if (showSubCat) {
			sub_cat_select = document.querySelector('select#subCategory');
			selectedCategory = categories.filter((cat) => {
				return cat.name === category;
			});

			setSelectedCat(...selectedCategory);

			selectedCategory[0].sub_categories
				? selectedCategory[0].sub_categories.forEach((option) => {
						sub_cat_select.insertAdjacentHTML(
							'beforeend',
							`<option value="${option.name}"
			                            key="${option.name}">${option.name}</option>`
						);
				  })
				: setShowSubCat(false);
		}
	}, [showSubCat, category]);

	/* Get specializations */
	useEffect(() => {
		const specializations_select = document.querySelector(
			'select#specialization'
		);

		if (showSpecialization) {
			selectedSubCategory = selectedCat.sub_categories.filter((subCat) => {
				return subCat.name === subCategory;
			});

			selectedSubCategory[0].specializations
				? selectedSubCategory[0].specializations.forEach((i) => {
						specializations_select.insertAdjacentHTML(
							'beforeend',
							`<option value="${i}"
							key="${i}">${i}</option>`
						);
						// TODO: I need to make the specializations into a map instead of an array and then uncommentout the code below:
						// specializations_select.insertAdjacentHTML(
						// 	'beforeend',
						// 	`<option value=${option.name}
						// 		key=${option.name}>${option.name}</option>`
						// );
				  })
				: setShowSpecialization(false);
		}
	}, [showSpecialization, subCategory]);
	/* eslint-enable */

	const handleSelectChange = (e) => {
		let target = e.currentTarget.id;
		if (target === 'category') {
			setCategory('');
			setSubCategory('');
			setShowSubCat(false);
			setShowSpecialization(false);
			setCategory(e.target.value);
			setShowSubCat(true);
		} else if (target === 'subCategory') {
			setSubCategory(e.target.value);
			setShowSpecialization(true);
		} else if (target === 'specialization') {
			changeFn(e);
		} else {
			console.log("There's an issue");
		}
	};

	return (
		<div>
			<div className='input-field'>
				{/* ===== SELECT A CATEGORY ===== */}
				<select
					className='browser-default'
					id='category'
					defaultValue={'default'}
					onChange={handleSelectChange}
					tabIndex='1'>
					<option value='default' disabled>
						-- Select a category --
					</option>
					{categories &&
						categories.map((option) => {
							return (
								<option
									value={`${option.name}`}
									key={`${option.id}`}>{`${option.name}`}</option>
							);
						})}
				</select>

				<label htmlFor='category'></label>
			</div>
			{/* ===== SELECT A SUBCATEGORY ===== */}
			{showSubCat && (
				<div className='input-field'>
					<select
						className='browser-default'
						id='subCategory'
						defaultValue={'default'}
						onChange={handleSelectChange}
						required
						tabIndex='2'>
						<option value='default' disabled>
							-- Select a subcategory --
						</option>
					</select>
					<label htmlFor='subCategory'> </label>
				</div>
			)}
			{/* ===== SELECT A SPECIALIZATION ===== */}
			{showSpecialization && (
				<div className='input-field'>
					<select
						className='browser-default'
						id='specialization'
						defaultValue={'default'}
						onChange={handleSelectChange}
						tabIndex='3'>
						<option value='default' disabled>
							-- Select a specialization --
						</option>
					</select>
					<label htmlFor='specialization'> </label>
				</div>
			)}
		</div>
	);
};

export default SelectSpecialization;
